import moment from 'moment';
import { useHistory } from 'react-router-dom';

import BookingSuccess from './../../../../../../../assets/custom/booking-success.gif';
import BookingFailure from './../../../../../../../assets/custom/booking-failure.gif';
import DropIcon from './../../../../../../../assets/custom/drop.png';
import PickupIcon from './../../../../../../../assets/custom/pickup.png';

import BabySeatIcon from './../../../../../../../assets/custom/baby-seat.png';
import ChildIcon from './../../../../../../../assets/custom/child.png';
import LuggageIcon from './../../../../../../../assets/custom/luggage.png';
import UserIcon from './../../../../../../../assets/custom/user.png';
import { Constant } from '../../../../../../Helpers/constant';
import { useDispatch } from 'react-redux';
import {
  CREATE_AIRPORT_TRANSFER_BOOKING_EMPTY,
  CREATE_CLIENT_USER_EMPTY,
  GET_AIRPORTS_BASED_ON_CONFIG_ID_EMPTY,
  GET_AUTOCOMPLETE_LOCATION_EMPTY,
  GET_BENEFIT_ITEMS_EMPTY,
  GET_BINS_LIST_EMPTY,
  GET_CLIENT_BENEFIT_CONFIG_EMPTY,
  GET_MEMBERSHIPS_DATA_EMPTY,
  GET_PAYMENT_SUMMARY_EMPTY,
  GET_RECENT_SEARCHES_EMPTY,
  VALIDATE_FLIGHT_DETAILS_EMPTY,
  VALIDATE_LOCATION_EMPTY,
} from '../../../../../../../store/actions';

export default function BookingDetails({ bookingData, setCurrentScreen, setSelectedConfig, setBookingsDetails, setIsUserExist }) {
  const history = useHistory();
  const dispatch = useDispatch();

  const bookingStatus = Constant.BOOKING_STATUSES.filter(status => status?.objectId === bookingData?.bookingStatusCode)[0];

  const handleBackToAdmin = () => {
    dispatch({
      type: GET_AIRPORTS_BASED_ON_CONFIG_ID_EMPTY,
    });

    dispatch({
      type: GET_AUTOCOMPLETE_LOCATION_EMPTY,
    });

    dispatch({
      type: GET_RECENT_SEARCHES_EMPTY,
    });

    dispatch({
      type: VALIDATE_LOCATION_EMPTY,
    });

    dispatch({
      type: VALIDATE_FLIGHT_DETAILS_EMPTY,
    });

    dispatch({
      type: CREATE_AIRPORT_TRANSFER_BOOKING_EMPTY,
    });

    dispatch({
      type: GET_PAYMENT_SUMMARY_EMPTY,
    });

    dispatch({
      type: CREATE_CLIENT_USER_EMPTY,
    });

    dispatch({
      type: GET_BENEFIT_ITEMS_EMPTY,
    });

    dispatch({
      type: GET_BINS_LIST_EMPTY,
    });

    dispatch({
      type: GET_CLIENT_BENEFIT_CONFIG_EMPTY,
    });

    dispatch({
      type: GET_MEMBERSHIPS_DATA_EMPTY,
    });

    setSelectedConfig(null);
    setBookingsDetails(null);
    setIsUserExist(null);
    setCurrentScreen(`USER_DETAILS`);

    // history.push(`/client/dashboard`);
  };

  return (
    <div className="booking-details-main-container">
      <div className="booking-type-heading">
        <p>Airport Transfer</p>
      </div>
      {[0, 17, 16]?.includes(bookingData?.bookingStatusCode) ? (
        <div className="booking-status-icon">
          <img src={BookingFailure} alt="" className="booking-success" />
        </div>
      ) : (
        <div className="booking-status-icon">
          <img src={BookingSuccess} alt="" className="booking-success" />
        </div>
      )}
      {[0, 17, 16]?.includes(bookingData?.bookingStatusCode) ? (
        <div className="booking-status-salutation">
          <p>Failed!!</p>
        </div>
      ) : (
        <div className="booking-status-salutation">
          <p>Congratulations</p>
        </div>
      )}
      {[0, 17, 16]?.includes(bookingData?.bookingStatusCode) ? (
        <div className="booking-status-secondary-text">
          <p> We couldn’t verify your card details. Please try again with correct card.</p>
        </div>
      ) : (
        <div className="booking-status-secondary-text">
          <p>We have received your booking request.</p>
        </div>
      )}
      <div className="booking-details-wrapper">
        <label>Location Details</label>

        <div className="booking-details-container">
          <div className="booking-details-left">
            <div className="pickup-location-icon">
              <img src={PickupIcon} alt="" className="pickup" />
            </div>
            <div className="drop-location-icon">
              <img src={DropIcon} alt="" className="drop" />
            </div>
            <div className="dashed-separator"></div>
          </div>

          <div className="booking-details-right">
            <div className="pickup-location">
              <div className="location-main-heading">{bookingData?.pickupLocation?.name}</div>
              <div className="location-secondary-text">{bookingData?.pickupLocation?.address}</div>
            </div>

            <div className="drop-location">
              <div className="location-main-heading">{bookingData?.dropLocation?.name}</div>
              <div className="location-secondary-text">{bookingData?.dropLocation?.address}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="booking-core-details">
        <div className="booking-core">
          <div className="label">Booking ID</div>
          <div className="label-value">{bookingData?.bookingId}</div>
        </div>

        <div className="booking-core" style={{ textAlign: 'center' }}>
          <div className="label">Booking Placed On</div>
          <div className="label-value">
            {' '}
            {moment(new Date(bookingData?.createdAt)).format('DD/MM/yyyy')}{' '}
            {new Date(bookingData?.createdAt)?.toLocaleTimeString([], {
              hour12: true,
              hour: '2-digit',
              minute: '2-digit',
            })}
          </div>
        </div>

        {/* <div className="booking-core" style={{ textAlign: 'end' }}>
          <div className="label">Car Type</div>
          <div className="label-value">{bookingData?.chauffer?.carType}</div>
        </div> */}

        <div className="booking-core" style={{ textAlign: 'end' }}>
          <div className="label">Pickup Date</div>
          <div className="label-value">{moment(bookingData?.pickupDate).format('DD MMMM YYYY')}</div>
        </div>

        <div className="booking-core">
          <div className="label">Pickup Time</div>
          <div className="label-value"> {moment(bookingData?.pickupTime, 'HH:mm').format('hh:mm A')}</div>
        </div>
      </div>
      <div className="booking-passenger-details">
        <div className="booking-passenger">
          <div className="booking-passenger-container">
            <div className="booking-passenger-icon">
              <img src={UserIcon} alt="" />
            </div>
            <div className="booking-passenger-count"> {bookingData?.numberOfPassengers}</div>
          </div>
          <div className="booking-passenger-label">Passenger</div>
        </div>

        <div className="booking-passenger">
          <div className="booking-passenger-container">
            <div className="booking-passenger-icon">
              <img src={BabySeatIcon} alt="" />
            </div>
            <div className="booking-passenger-count"> {bookingData?.numberOfBabySeats}</div>
          </div>
          <div className="booking-passenger-label">Baby Seat</div>
        </div>

        <div className="booking-passenger">
          <div className="booking-passenger-container">
            <div className="booking-passenger-icon">
              <img src={ChildIcon} alt="" />
            </div>
            <div className="booking-passenger-count"> {bookingData?.numberOfInfants ?? 0}</div>
          </div>
          <div className="booking-passenger-label">Infant Seat</div>
        </div>

        <div className="booking-passenger">
          <div className="booking-passenger-container">
            <div className="booking-passenger-icon">
              <img src={LuggageIcon} alt="" />
            </div>
            <div className="booking-passenger-count"> {bookingData?.numberOfLuggages}</div>
          </div>
          <div className="booking-passenger-label">Luggage</div>
        </div>
      </div>
      {/* TODO: Add back to admin button */}
      <div
        className="cta-back-to-admin"
        onClick={() => {
          // handleBackToAdmin();
          window.location.reload();
        }}
      >
        <button>Back to Admin</button>
      </div>
    </div>
  );
}
